const data = {
	"width": 36,
	"height": 36,
	"body": "<path fill=\"currentColor\" d=\"M32.16 16.08L8.94 4.47A2.07 2.07 0 0 0 6 6.32v23.21a2.06 2.06 0 0 0 3 1.85l23.16-11.61a2.07 2.07 0 0 0 0-3.7Z\" class=\"clr-i-solid clr-i-solid-path-1\"/><path fill=\"none\" d=\"M0 0h36v36H0z\"/>"
};
exports.__esModule = true;
exports.default = data;
